import { buildMockPromise } from "../api/helpers";
import {
  ReportLog,
  ReportSummaryApi,
  ReportSummaryItemApi,
  REPORT_STATUS_ENUM,
  ProductReport,
  REPORT_TYPES,
} from "../api/Reports";
import {
  WORKFLOW_STATUS_ENUM,
  WORKFLOW_STEP_STATUS_ENUM,
} from "../api/Workflows";

const defaultcompany = {
  id: 0,
  external_id: "1530bdcc-4677-4038-ab7d-c7983717c4ac",
  created_at: "2022-07-05T16:43:49.847443",
  modified_at: "2022-07-05T16:43:49.847448",
  is_deleted: false,
  modified_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  parent_company_id: 0,
  notes: "Some notes for this company",
  is_active: true,
  name: "Company X",
};

const reportsInfoList: ReportSummaryItemApi[] = [
  {
    report_uuid: "rep15f64-5717-4562-b3fc-2c963f66afa6",
    report_date_added: "2022-07-05T16:57:57.219Z",
    total_ratings: 12,
    full_name: "Person Name (DONE)",
    report_status: REPORT_STATUS_ENUM.DONE,
    workflow_status: WORKFLOW_STATUS_ENUM.DONE,
    due_date: "2022-08-15T16:57:57.219Z",
    created_at: "2022-08-15T16:57:57.219Z",
    due_date_updated: true,
    finish_at: "2022-07-04T16:57:57.219Z",
    client_report_id: "",
    is_locked: false,
    sla_met: true,
    company_name: defaultcompany.name,
    company_uuid: defaultcompany.external_id,
    company_note: "",
    banner_notes: "",
    parent_company_name: "",
    parent_company_uuid: "",
    step_name: "In Progress",
    workflow_run_uuid: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    locked_by: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    locked_by_name: "Analist 1",
    person_uuid: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    blueprint_uuid: "t3r2dfgb4-5717-4562-b3fc-2c963f66afa6",
    blueprint_name: "Express-Check",
    has_rerun: false,
    was_amend: false,
    job_title: "None",
  },
  {
    report_uuid: "rep16f64-5717-4562-b3fc-2c963f66afa6",
    report_date_added: "2022-08-20T16:57:57.219Z",
    total_ratings: 12,
    full_name: "Person Name (IN_PROGRESS)",
    report_status: REPORT_STATUS_ENUM.IN_PROGRESS,
    workflow_status: WORKFLOW_STATUS_ENUM.IN_PROGRESS,
    due_date: "2022-08-20T16:57:57.219Z",
    due_date_updated: false,
    created_at: "2022-08-15T16:57:57.219Z",
    finish_at: "",
    client_report_id: "",
    is_locked: false,
    sla_met: true,
    company_name: defaultcompany.name,
    company_uuid: defaultcompany.external_id,
    company_note: "",
    banner_notes: "",
    parent_company_name: "",
    parent_company_uuid: "",
    step_name: WORKFLOW_STEP_STATUS_ENUM.PostsManualRate,
    workflow_run_uuid: "rep25f64-5717-4562-b3fc-2c963f66afa6",
    locked_by: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    locked_by_name: "Analist 2",
    person_uuid: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    blueprint_uuid: "t3r2dfgb4-5717-4562-b3fc-2c963f66afa6",
    blueprint_name: "Express-Check",
    has_rerun: false,
    was_amend: false,
    job_title: "None",
  },
  {
    report_uuid: "rep17f64-5717-4562-b3fc-2c963f66afa6",
    report_date_added: "2022-08-20T16:57:57.219Z",
    total_ratings: 12,
    full_name: "Person Name (IN_PROGRESS)",
    report_status: REPORT_STATUS_ENUM.IN_PROGRESS,
    workflow_status: WORKFLOW_STATUS_ENUM.IN_PROGRESS,
    due_date: "2022-08-20T16:57:57.219Z",
    due_date_updated: false,
    created_at: "2022-08-15T16:57:57.219Z",
    finish_at: "",
    client_report_id: "",
    is_locked: false,
    sla_met: true,
    company_name: defaultcompany.name,
    company_uuid: defaultcompany.external_id,
    company_note: "",
    banner_notes: "",
    parent_company_name: "",
    parent_company_uuid: "",
    step_name: WORKFLOW_STEP_STATUS_ENUM.ProfilesManualRate,
    workflow_run_uuid: "rep25f64-5717-4562-b3fc-2c963f66afa6",
    locked_by: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    locked_by_name: "Analist 3",
    person_uuid: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
    blueprint_uuid: "t3r2dfgb4-5717-4562-b3fc-2c963f66afa6",
    blueprint_name: "Express-Check",
    has_rerun: false,
    was_amend: false,
    job_title: "None",
  },
];

function getRandomReportStatus(): string {
  const statuses = [
    REPORT_STATUS_ENUM.NEW,
    REPORT_STATUS_ENUM.IN_PROGRESS,
    REPORT_STATUS_ENUM.RE_RUN,
    REPORT_STATUS_ENUM.CANCEL,
    REPORT_STATUS_ENUM.DONE,
    REPORT_STATUS_ENUM.AMENDMENT,
  ];
  return statuses[Math.floor(Math.random() * statuses.length)];
}

function getRandomWorkflowStatus(): string {
  const statuses = [
    WORKFLOW_STATUS_ENUM.TO_DO,
    WORKFLOW_STATUS_ENUM.IN_PROGRESS,
    WORKFLOW_STATUS_ENUM.DONE,
    WORKFLOW_STATUS_ENUM.FAILED,
    WORKFLOW_STATUS_ENUM.TIMEOUT,
    WORKFLOW_STATUS_ENUM.CANCELLED,
  ];
  return statuses[Math.floor(Math.random() * statuses.length)];
}

function getRandomStepStatus(): string {
  const statuses = [
    WORKFLOW_STEP_STATUS_ENUM.ProfilesModelPredict,
    WORKFLOW_STEP_STATUS_ENUM.ProfilesAutoRate,
    WORKFLOW_STEP_STATUS_ENUM.ProfilesManualRate,
    WORKFLOW_STEP_STATUS_ENUM.PersonEnrichment,
    WORKFLOW_STEP_STATUS_ENUM.ProfilePostScrape,
    WORKFLOW_STEP_STATUS_ENUM.PostsModelPredict,
    WORKFLOW_STEP_STATUS_ENUM.PostsAutoRate,
    WORKFLOW_STEP_STATUS_ENUM.PostsManualRate,
    WORKFLOW_STEP_STATUS_ENUM.FinalReportQA,
    WORKFLOW_STEP_STATUS_ENUM.PDFGeneration,
  ];
  return statuses[Math.floor(Math.random() * statuses.length)];
}

function buildReportListMock(numItems: number): ReportSummaryApi {
  const list: ReportSummaryItemApi[] = [];
  for (let i = 1; i <= numItems; i++) {
    if (i >= 1 && i < reportsInfoList.length + 1) {
      list.push(reportsInfoList[i - 1]);
    } else {
      list.push({
        report_uuid: `${i}fa85f64-5717-4562-b3fc-2c963f66afa6`,
        report_date_added: "2022-07-05T16:57:57.219Z",
        total_ratings: Math.floor(Math.random() * numItems),
        full_name: `Custom Name ${i}`,
        report_status: getRandomReportStatus(),
        workflow_status: getRandomWorkflowStatus(),
        due_date: "2022-08-25T23:57:57.219Z",
        due_date_updated: Math.random() > 0.75,
        finish_at: "2022-07-05T16:57:57.219Z",
        created_at: "2022-08-15T16:57:57.219Z",
        client_report_id: "",
        is_locked: true,
        sla_met: Math.random() > 0.5,
        company_name: {
          ...defaultcompany,
          name: `Company ${i}`,
        }.name,
        company_uuid: defaultcompany.external_id,
        company_note: "",
        banner_notes: "",
        parent_company_name: "",
        parent_company_uuid: "",
        workflow_run_uuid: "",
        step_name: getRandomStepStatus(),
        locked_by: "",
        locked_by_name: `Custom Name ${i}`,
        person_uuid: "wkfl15f64-5717-4562-b3fc-2c963f66afa6",
        blueprint_uuid: "t3r2dfgb4-5717-4562-b3fc-2c963f66afa6",
        blueprint_name: "Express-check",
        has_rerun: false,
        was_amend: false,
        job_title: "None",
      });
    }
  }

  return {
    report_summaries: list,
    message: "OK",
    total_rows: 100,
  };
}

export async function getReportsInfoListMock(): Promise<ReportSummaryApi> {
  const numberOfMockedItems = 100;
  let list = buildReportListMock(numberOfMockedItems);
  return await buildMockPromise<ReportSummaryApi>(list);
}

export async function getReportByReportUUIDMock(
  reportUUID: string
): Promise<ReportSummaryItemApi> {
  let reportSummaryItem = reportsInfoList[0];
  return await buildMockPromise({
    ...reportSummaryItem,
    workflow_run_uuid: reportUUID,
  });
}

export async function getReportLogsMock(
  numItems: number
): Promise<ReportLog[]> {
  const list: ReportLog[] = [];
  for (let i = 1; i <= numItems; i++) {
    list.push({
      external_id: `${i}fa85f64-5717-4562-b3fc-2c963f66afa6`,
      log_message: `Custom Message ${i}`,
      type: `Custom Type ${2}`,
      created_at: new Date(),
      modified_at: new Date(),
      modified_by: `${i}fa85f64-5717-4562-b3fc-2c963f66afa6`,
      name: `Name ${i}`,
      is_user: Math.random() > 0.5,
    });
  }

  return list;
}

export async function getReportProductReportsMock(): Promise<ProductReport[]> {
  return await buildMockPromise([
    {
      id: 7777,
      external_id: "f3be5f68-9d5e-475b-ab62-abc93fd6e6a8",
      created_at: "2025-10-30T19:57:02+00:00",
      modified_at: "2025-10-30T20:08:19+00:00",
      is_deleted: false,
      modified_by: "4bc97f20-7f2a-4809-83ff-45c9ce4441a1",
      report_id: 11342,
      status: "IN_PROGRESS",
      report_type: REPORT_TYPES.THREE_SIXTY,
      file_id: 0,
      blueprint_uuid: "a52d200f-bc77-4656-b1f9-56bb07418b76",
      reviewed: false,
      content: {
        due_date: "2025-11-03T21:00:00+00:00",
        blueprint: {
          id: 781,
          name: "360-Full",
          color: "",
          is_root: false,
          lookback: 1,
          is_active: true,
          sla_hours: 0,
          created_at: "2025-08-18T23:25:44+00:00",
          is_deleted: false,
          copied_from: 646,
          external_id: "a52d200f-bc77-4656-b1f9-56bb07418b76",
          is_template: true,
          modified_at: "2025-08-18T23:25:44+00:00",
          modified_by: "698a0615-4f12-11ed-b125-3a206d886597",
          report_type: "360",
          turn_around: "BUSINESS_DAYS",
          steps_to_skip: "",
          workflow_config_uuid: "75ed8841-2d23-492c-98fa-d8f71f874993",
        },
        custom_id: "",
        job_title: "None",
        behavior_kit: null,
        company_name: "Grant Company",
        requested_by: "d9cd0b7a-9f27-448b-97e5-18f79a12f858",
        assessment_id: "",
        payment_token: "",
        misconduct_report: "DONE",
        misconduct_report_finished_at: "2025-10-30T20:08:19.048655+00:00",
      },
      name: "Grant LexisOne",
    },
  ]);
}
